module.exports = __webpack_public_path__ + "img/library.958a2490.svg";